/**
 * 该mixin使用场景：
 * 当页面被keep-alive包裹，并且watch 了路由或者vuex中相关的内容，watch会在页面失焦和重新被激活时，触发两次。
 * 为解决该问题，需要引入该mixin，在watch的地方，增加一个判断，当activatedFlag为true时，再执行watch内容。
 * **/
export default {
  name: 'KeepAlivePageMixin',
  data() {
    return {
      activatedFlag: false,
    }
  },
  mounted() {
    this.activatedFlag = true
  },
  activated() {
    this.activatedFlag = true
  },
  deactivated() {
    this.activatedFlag = false
  },
  
}
